import { Component, OnInit, OnDestroy, ViewChild, Input, Output, OnChanges, SimpleChange, AfterViewInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { NormasService } from "../_services/normas.service";

import { Nivel } from '../_models/nivel.model';
import { Pregunta } from '../_models/pregunta.model';

import { EvidenciasService } from '../_services/evidencias.service';
import { ModalDirective } from 'ng2-bootstrap/modal';

declare var jQuery: any;

@Component({
  selector: 'modalmodulosafectados',
  templateUrl: 'modalmodulosafectados.template.html'
})
export class ModalModulosAfectadosComponent  implements OnInit, OnDestroy, OnChanges, AfterViewInit{

  @Input() _mostrarmodal: any;
  @Input() _id: any;
  @Input() _desde: string = "norma";

  @Output() onChangeModal = new EventEmitter<any>();

  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;

  listamodulos: any = [];
  listamodulosseleccionados: any = [];


  sortby: any;
  sortdirection : any;
  evidenciasfijas: any;
  evidenciascuestionario: any;

  mostrarEmrpresasAfectadas:boolean = false;


  public filterQuery = "";

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private evidenciasService: EvidenciasService,
              private activatedRoute: ActivatedRoute){

  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    /*if (changes['_id_respuesta']){
      this.id_respuesta = changes['_id_respuesta'].currentValue;
    }*/

    this.getListaModulos();
  }

  ngOnInit(){

  }

  ngOnDestroy(){

  }

  ngAfterViewInit(){
    this.abrirModal();

  }

  getListaModulos(){

    console.log(this._desde);

    if (this._desde == "norma"){
      this.normasService.getNormaMaestra(this._id).subscribe(
          data => {
            if (data){

              let modul = data.json().norma.modulosafectados;

              this.listamodulos = [];
              if (modul){
                this.listamodulos = modul;
              }

              if (this.listamodulos.length > 0){

                setTimeout(() => this.inicializarCheck(), 500);

              }else{
                this.cerrarModal();
              }

            }
          }
      );
    }else{
      this.evidenciasService.getEvidenciaMaestra(this._id).subscribe(
          data => {
            if (data){

              console.log(data.json());

              let modul = data.json().evidencia.modulosafectados;

              this.listamodulos = [];
              if (modul){
                this.listamodulos = modul;
              }

              if (this.listamodulos.length > 0){

                setTimeout(() => this.inicializarCheck(), 500);

              }else{
                this.cerrarModal();
              }

            }
          }
      );
    }


  }

  abrirModal(){
    if (this._mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(){
    this.staticModalRespuestas.hide();
    this.onChangeModal.emit("");
  }

  comprobarCheck(){
    for (let i = 0; i < this.listamodulosseleccionados.length; i++) {

        jQuery('#check_'+this.listamodulosseleccionados[i].id_modulo).prop("checked", true);

    }
  }

  inicializarCheck(){
    for (let modulo of this.listamodulos){
      this.listamodulosseleccionados.push(modulo);
      jQuery('#check_'+modulo.id_modulo).prop("checked", true);
    }
  }

  anadirModulo(modulo: any, event: any){

    let encontrado: number;

    if (jQuery('#check_'+event).is(':checked')) {
      this.listamodulosseleccionados.push(modulo);
    }else{
      for (let i = 0; i < this.listamodulosseleccionados.length; i++) {
        if (this.listamodulosseleccionados[i].id_modulo == modulo.id_modulo){

          encontrado = i;
        }

      }

      this.listamodulosseleccionados.splice(encontrado,1);
    }

    console.log(this.listamodulosseleccionados);
  }

  actualizarModulos(){


    if (this._desde == "norma"){
      this.normasService.setModulosAfectados(this.listamodulosseleccionados).subscribe(
        data => {
          if (data){

            let al: any = {
              "texto" : "Módulos afectados actualizados",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);

            this.cerrarModal();
          }
        }
      );

    }else{
      this.evidenciasService.setModulosAfectados(this.listamodulosseleccionados).subscribe(
        data => {
          if (data){

            let al: any = {
              "texto" : "Módulos afectados actualizados",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);

            this.cerrarModal();
          }
        }
      );
    }



  }

}



// WEBPACK FOOTER //
// ./src/app/normas/modalmodulosafectados.component.ts